import { useEffect, useState } from "react";
import { categories } from "@/mocks/products";

interface Props {
  activeCategory: string;
  onCategoryChange: (id: string) => void;
}

export default function ProductsHero({ activeCategory, onCategoryChange }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative pt-20 overflow-hidden bg-[#1e1a16]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=collection%20of%20Tibetan%20dzi%20beads%20natural%20crystals%20jade%20jewelry%20thangka%20art%20arranged%20on%20dark%20stone%20surface%20luxury%20oriental%20aesthetic%20warm%20golden%20atmospheric%20light%20high%20end%20product%20photography%20serene%20spiritual&width=1920&height=700&seq=prod_hero001&orientation=landscape"
          alt="能量系列"
          className="w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e1a16]/60 via-[#1e1a16]/50 to-[#1e1a16]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 pt-20 pb-0">
        {/* Title */}
        <div
          className={`text-center mb-14 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#c9a96e]"></span>
            <span
              className="text-[#c9a96e] text-[1rem] tracking-[0.35em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              ENERGY COLLECTION
            </span>
            <span className="w-10 h-px bg-[#c9a96e]"></span>
          </div>
          <h1
            className="text-white font-bold mb-4 leading-[1.3]"
            style={{
              fontSize: "clamp(2rem, 4vw, 2.75rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            能量系列
          </h1>
          <p
            className="text-white/60 max-w-xl mx-auto leading-[1.75]"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            嚴選西藏天珠、天然水晶礦石、翡翠玉石與唐卡佛牌，每一件都是天地能量與手作溫度的結晶。
          </p>
        </div>

        {/* Category Tabs */}
        <div
          className={`transition-all duration-1000 delay-200 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <div className="flex flex-wrap justify-center gap-3 pb-0">
            {categories.map((cat) => {
              const isActive = activeCategory === cat.id;
              return (
                <button
                  key={cat.id}
                  onClick={() => onCategoryChange(cat.id)}
                  className={`flex items-center gap-2.5 px-6 py-3 rounded-full text-[1rem] font-medium tracking-wide whitespace-nowrap cursor-pointer transition-all duration-300 ${
                    isActive
                      ? "bg-[#c9a96e] text-[#1e1a16]"
                      : "bg-white/10 text-white/70 hover:bg-white/20 hover:text-white border border-white/15"
                  }`}
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.label}
                </button>
              );
            })}
          </div>

          {/* Active Category Description */}
          <div className="h-16 flex items-center justify-center">
            {categories.filter((c) => c.id === activeCategory && c.id !== "all").map((cat) => (
              <p
                key={cat.id}
                className="text-white/40 text-[1rem] tracking-widest"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                {cat.desc}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
